// Core module
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

// Application services
import { AuthService } from '@core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Personal-information component
 */
@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {

  public profileForm: UntypedFormGroup;
  public campaignId: number;
  public location: GeolocationPosition

  /**
   * Life cycle method
   * @param authService AuthService
   * @param fb FormBuilder
   */
  constructor(
    private authService: AuthService,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private translate: TranslateService
  ) { }

  /**
   * Life cycle init method
   */
  ngOnInit(): void {
    this.initializeForm();
    this.authService.getUser().subscribe((data) => {
      if (data.dateOfBirth) {
        data.dateOfBirth = data.dateOfBirth.split('T')[0];
      }
      this.profileForm.patchValue(data);
    });
  }

  /**
   * Initialize form
   */
  initializeForm() {
    this.profileForm = this.fb.group({
      firstName: new UntypedFormControl('', [Validators.required]),
      lastName: new UntypedFormControl('', [Validators.required]),
      dateOfBirth: new UntypedFormControl('', [Validators.required]),
      gender: new UntypedFormControl('', [Validators.required]),
      optIn: new UntypedFormControl('', [Validators.required]),
    });
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition((location) => {
    //     this.location = location;
    //   });
    // }
  }

  // Returns first name
  get firstName(): AbstractControl {
    return this.profileForm.get('firstName');
  }

  // Returns last name
  get lastName(): AbstractControl {
    return this.profileForm.get('lastName');
  }

  // Return confirm password
  get dateOfBirth(): AbstractControl {
    return this.profileForm.get('dateOfBirth');
  }

    // Return confirm password
  get gender(): AbstractControl {
      return this.profileForm.get('gender');
  }

  get optIn(): AbstractControl {
    return this.profileForm.get('optIn');
  }
  /**
   * Update profile
   */
  updateProfile(): void {
    if (this.profileForm.valid) {
      const payload = this.profileForm.value;
      payload.dateOfBirth = new DatePipe('nl-NL').transform(this.dateOfBirth.value, 'MM-dd-yyyy');
      // payload.dateOfBirth = new Date(this.dateOfBirth.value).toUTCString();
      if (this.location) {
        payload.latitude = this.location.coords.latitude;
        payload.longitude = this.location.coords.longitude;
      }
      this.authService.saveUser(payload).subscribe(
        (result) => {
          this.authService.setUsername(result.firstName);
          this.snackBar.open(this.translate.instant('PROFILE_SAVED'), 'X', { duration: 3000 });
        },
        () => this.snackBar.open(this.translate.instant('ERROR_OCCURRED'), 'X', { duration: 3000 })
      );
    }
  }

  close(): void {
    this.router.navigate([`/`]);
  }
}
